import {AbstractService} from 'services/AbstractService';


const CURRENT_ACCOUNT_PROJECTS_LIST = '/api/projects';
const ACCOUNT_PROJECTS_LIST_SIMPLE = '/api/projects/simple';
const PROJECT_DETAILS = '/api/projects/{0}';
const PROJECT_CREATE = '/api/projects';
const PROJECT_UPDATE_STATUS_URL = '/api/projects/{0}/status';

export class ProjectsService extends AbstractService {
  async getAccountProjectsList (accountId, params = {}) {
    return this.client.get(CURRENT_ACCOUNT_PROJECTS_LIST, params, {accountId});
  }

  getAccountProjectsListSimple (accountId, params = {}, axiosParams = {}) {
    let _accountId = accountId;
    let _accountIds = [];
    if (Array.isArray(_accountId)) {
      _accountIds = accountId;
      _accountId = null;
    }

    return this.client.get(ACCOUNT_PROJECTS_LIST_SIMPLE, {
      ...params,
      account_id: _accountIds
    }, {accountId: _accountId}, axiosParams);
  }

  async getProjectDetails (accountId, projectId, axiosParams) {
    return await this.client.get(PROJECT_DETAILS.format(projectId), {}, {accountId}, axiosParams);
  }

  updateProjectStatus (accountId, projectId, newStatus, saveParams = {}) {
    return this.client.put(PROJECT_UPDATE_STATUS_URL.format(projectId),
      {status: newStatus}, {accountId}, {params: saveParams}
    );
  }

  async updateProject (accountId, projectId, projectData) {
    return await this.client.put(PROJECT_DETAILS.format(projectId), projectData, {accountId});
  }

  async createProject (accountId, params = {}) {

    return await this.client.post(
      PROJECT_CREATE,
      params,
      {accountId}
    );
  }
}
